exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.coordinates-container {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-self: flex-end;\n  align-self: flex-end;\n}\n.map-coordinates {\n  background-color: rgba(0, 60, 136, 0.3);\n  border-radius: 4px;\n  padding: 5px;\n  margin: 0.5em;\n  min-width: 230px;\n  text-align: center;\n}\n.map-coordinates-field {\n  pointer-events: all;\n}\n#map-coordinates {\n  color: #fff;\n}\n#map-scale {\n  position: relative;\n}\n.ol-scale-line {\n  bottom: 0.5em;\n  right: 0.5em;\n  left: inherit;\n}\n", ""]);

// exports
